import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonItem,
  IonList,
  IonRow,
  IonTitle,
} from "@ionic/react";
import { FunctionComponent, useContext, useEffect, useState } from "react";
import { DataContext } from "../context/DataContext";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks" ;
import remarkGfm from "remark-gfm";
import rehypeRaw from 'rehype-raw' ;
import { RouteComponentProps } from "react-router-dom" ;
import { ContentParkraum } from "../contents/ContentParkraum";
import { CompAnlagen } from "../components/CompAnlagen";
import axios from "axios";
import './toastui-solufind.css' ;

const dummyImg = 'data:image/png;base64,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' ;

const PageInhalt: FunctionComponent<RouteComponentProps> = ( props ) => {
  const { appMenueItems , appNewsItems , appTarife , appParkraeume , appParkraeumeTarife } = useContext(DataContext);

  const [ titel, setTitel ] = useState( '' ) ;
  const [ untertitel, setUntertitel ] = useState( '' ) ;
  const [ content, setContent ] = useState( '' ) ;
  const [ image, setImage ] = useState( <></> ) ;
  const [ showNews , setShowNews ] = useState( '' ) ;
  const [ showSeite , setShowSeite ] = useState( '' ) ;
  const [ showTarife , setShowTarife ] = useState( '' ) ;
  const [ showParkraeume , setShowParkraeume ] = useState( '' ) ;
  const [ triedNewsSingleItem , setTriedNewsSingleItem ]:any = useState() ;

  useEffect(
    function checkUrl()
      {
        // @ts-ignore
        if( props.match.url.slice( -1 ) === '/' ) {
          mkSubmenu() ;
          return ;
        }
        // @ts-ignore
        let content_id = props.match.params.id ;
        if( content_id ) {
          switch( props.match.url.split( '/' )[ 1 ] ) {
            case 'news':
              if( content_id !== showNews ) {
                setShowNews( content_id ) ;
                setShowSeite( '' ) ;
                setShowTarife( '' ) ;
                setShowParkraeume( '' ) ;
              }
              break ;
            case 'parkraeume':
              if( content_id !== showTarife ) {
                setShowParkraeume( content_id ) ;
                setShowNews( '' ) ;
                setShowSeite( '' ) ;
                setShowTarife( '' ) ;
              }
              break ;
            case 'tarife':
              if( content_id !== showTarife ) {
                setShowTarife( content_id ) ;
                setShowNews( '' ) ;
                setShowSeite( '' ) ;
                setShowParkraeume( '' ) ;
              }
              break ;
            default:
              if( content_id !== showSeite ) {
                setShowSeite( content_id ) ;
                setShowNews( '' ) ;
                setShowTarife( '' ) ;
                setShowParkraeume( '' ) ;
              }
              break ;
          }
        }
        else {
          getData( 404 , [ '' ] , 0 , 0 ) ;
        }
      }
      ,
      [ props.match.url ]
  ) ;

  const makeStellplaetze = ( data:any ) =>
    {
      let fields =
        [
          5 , 6 , 7 , 8 , 9 , 10 , 11 , 15
        ]
      ;
      let labels =
        {
          5: 'PKW' ,
          6: 'LKW' ,
          7: 'Wohnmobile' ,
          8: 'Busse' ,
          9: 'Elektrofahrzeuge' ,
          10: 'behindertengerecht' ,
          11: 'Motorräder' ,
          15: 'Fahrräder'
        }
      ;
      let my_data =
        data
          .map(
            ( entry:any , index:number ) =>
              {
                if( fields.includes( index ) && entry > 0 ){
                  return (
                    <tr
                      style =
                        {
                          {
                            backgroundColor: 'white'
                          }
                        }
                    >
                      <td>
                        {
                          // @ts-ignore
                          labels[ index ]
                        }
                      </td>
                      <td>
                        {
                          entry
                        }
                      </td>
                    </tr>
                  )            
                }
              }
          )
        ;
      return my_data ;
    }

    const makeParkraeumeTarife = ( parkraum_id:string ) =>
    {
      let my_data =
        appParkraeumeTarife
          .filter(
            ( entry:any ) =>
              {
                return entry.parkraum_tarif_parkraum === parkraum_id ;
              }
          )
          .map(
            ( entry:any ) =>
              {
                return entry.parkraum_tarif_tarif ;
              }
          )
      ;
      let my_tarife_arr =
        appTarife
          .filter(
            ( entry:any ) =>
              {
                return my_data.includes( entry[ 0 ] )
              }
          )
      let my_tarife_obj:any = {} ;
      my_tarife_arr
        .forEach(
          ( entry:any ) =>
            {
              my_tarife_obj[ entry[ 0 ] ] = {
                bezeichnung: entry[ 2 ] ,
                text: entry[ 3 ]
              } ;
            }
        )
      my_data =
        my_data
          .map(
            ( entry:any ) =>
              {
                return(
                  <IonGrid>
                    <IonRow>
                      <IonCol>
                        <h4>
                          { my_tarife_obj[ entry ].bezeichnung }
                        </h4>
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        <ReactMarkdown linkTarget = "_blank" rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkBreaks,remarkGfm]}>
                          { my_tarife_obj[ entry ].text }
                        </ReactMarkdown>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                )
              }    
          )
        ;
      return my_data ;
    }

  const getNewsSingleItem = async ( id:number ) =>
    {
      return axios
        .get(
          'https://api.parkraumpilot.de/api/artikel/get_artikel.php'
          + '?artikel_id=' + id
        )
        .then((res) => {
          let axios_response = res.data;
          return axios_response.data ;
        }
      );
    }
  
  type untertitel_data =
    {
      field?: number ,
      field_action?: ( field_val:string ) => string ,
      label?: string 
    }
  const getData = ( check_val:any , data:any , titel_field:number , content_field:number , image_field:number = 0 , untertitel_data:untertitel_data = {} ) =>
      {
        if( check_val !== '' ) {
          if( data.length === 0 ) {
            setTitel( '' ) ;
            setUntertitel( '' ) ;
            setContent( '\nLaden ...\n' ) ;
            setImage( <></> ) ;
          } else {
            let entry_found = false ;
            let my_titel = 'Seite "' + props.location.pathname + '" nicht gefunden' ;
            let my_untertitel = '' ;
            let my_content = '' ;
            let my_image =
              <IonList>
                <IonItem detail href = "javascript:window.history.back()" >zurück zur vorherigen Seite</IonItem>
                <IonItem routerLink = "/" >zur Startseite</IonItem>
              </IonList>
            ;
            for( let i = 0 ; i < data.length ; i++ ) {
              if( data[ i ][ 0 ] === check_val ) {
                entry_found = true ;
                my_titel = data[ i ][ titel_field ] ;
                if( untertitel_data.field ) {
                  if( untertitel_data.field_action ) {
                    my_untertitel = untertitel_data.field_action( data[ i ][ untertitel_data.field ] ) ;
                  }
                  else {
                    my_untertitel = data[ i ][ untertitel_data.field ] ;
                  }
                }
                else {
                  if( untertitel_data.label ) {
                    my_untertitel = untertitel_data.label ;
                  }
                }
                if( showParkraeume ) {
                  my_image = <ContentParkraum data = { data[ i ] } />
                }
                else {
                  my_content = data[ i ][ content_field ] ;
                  if( image_field !== 0 && data[ i ][ image_field ] !== dummyImg ) {
                    my_image = <IonItem lines = "none"><img src = { data[ i ][ image_field ] } style = {{ margin: 'auto' }}/></IonItem> ;
                  }
                  else {
                    my_image = <></> ;
                  }
                }
              }
            }
            if( ! entry_found && showNews && ! triedNewsSingleItem ) {
              my_titel = 'Nachladen ältere News-Seite "' + props.location.pathname + '" ...' ;
              setTriedNewsSingleItem( true ) ;
              getNewsSingleItem( check_val )
                .then(
                  ( res:any ) => {
                    if( res.length > 0 ) {
                      setTitel( res[ 0 ].artikel_titel ) ;
                      setUntertitel( new Date( res[ 0 ].artikel_datum ).toLocaleDateString() ) ;
                      setContent( res[ 0 ].artikel_text ) ;
                      setImage( <IonItem lines = "none"><img src = { res[ 0 ].artikel_bild  } style = {{ margin: 'auto' }}/></IonItem> ) ;
                    }
                  }
                )
            }
            setTitel( my_titel ) ;
            setUntertitel( my_untertitel ) ;
            setContent( my_content ) ;
            setImage( my_image ) ;
          }
        }
      }

  const mkSubmenu = () =>
    {
      let my_titel = props.match.url.slice( 1 , -1 ) ;
      let my_untertitel = '' ;
      let my_content = '' ;
      let my_items =
        appMenueItems
          .filter(
            ( entry:any ) =>
              {
                if( entry[ 9 ] === my_titel ) {
                  return true ;
                }
                return false ;
              }
          )
          .map(
            ( entry:any , index:number ) => {
              return(
                <IonItem 
                  key = { 'submenu_' + index } 
                  routerLink = { '/' + entry[ 2 ] + '_' + entry[ 0 ] }
                >
                  { entry[ 2 ] }
                </IonItem>
              )
            }
          )
      ;
      let my_image =
        <IonList>
          { my_items }
        </IonList> ;
      setTitel( my_titel ) ;
      setUntertitel( my_untertitel ) ;
      setContent( my_content ) ;
      setImage( my_image ) ;
    }

  useEffect(
    function dataSeite()
      {
        // @ts-ignore
        if( showSeite ) {
          getData( showSeite , appMenueItems , 4 , 6 , 5 ) ;
        }
      }
      ,
      [ appMenueItems , showSeite ]
  ) ;

  useEffect(
    function dataByNews()
      {
        if( showNews ) {
          getData( showNews , appNewsItems , 2 , 6 , 5 , { field: 3 , field_action: ( val:string ) => new Date( val ).toLocaleDateString() } ) ;
        }
      }
      ,
      [ appNewsItems , showNews ]
  ) ;

  useEffect(
    function dataByTarife()
      {
        if( showTarife ) {
          getData( showTarife , appTarife , 2 , 3 ) ;
        }
      }
      ,
      [ appTarife , showTarife ]
  ) ;

  useEffect(
    function dataByParkraeume()
      {
        if( showParkraeume ) {
          getData( showParkraeume , appParkraeume , 2 , 3 ) ;
        }
      }
      ,
      [ appParkraeume , showParkraeume ]
  ) ;

  return (
    <>
      <IonCard
        className="toastui-solufind"
      >
        <IonCardHeader>
          <IonCardTitle>{ titel }</IonCardTitle>
          { untertitel }
        </IonCardHeader>

        <IonCardContent
          style =
            {
              {
                overflow: 'auto'
              }
            }
        >
          { image }
          <ReactMarkdown linkTarget = "_blank" rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkBreaks,remarkGfm]}>
            { content }
          </ReactMarkdown>
          <CompAnlagen
            typ =
              {
                showSeite
                  ?
                    1
                  :
                    showNews
                      ?
                        2
                      :
                        0
              }
            zuordnung =
              {
                // @ts-ignore
                props.match.params.id
              }
          />
        </IonCardContent>
      </IonCard>
    </>
  );
};

export default PageInhalt;
